module.exports = __webpack_public_path__ + "img/faq-opened.378529b0.svg";